import { useEffect }              from 'react'
import { useFocusSet, useGet, get } from 'state/jotai'
import { useFetch }               from 'hooks/fetch/useFetch'
import { _isometry }              from 'state/store.isometry'
import { _bootstrap }             from 'state/store.bootstrap'
import { _lowerQualityIsometry }  from 'state/store.lowerQualityIsometry'
import { array }                  from 'utilities/utility.misc'
import { preloadImage }           from 'utilities/utility.images'
import { ISO_FRAMES, ISO_CONFIG } from 'api/api'

export const PreloadFrames_Mono = () => {

  const type   = useGet(_bootstrap).type
  const file   = 'main/Mono/MonoPreload.jsx'
  const mono   = type === 'mono'
  const url    = mono ? ISO_CONFIG : null
  const config = useFetch({ url, file }).D
  const lowQualityFrameStatus  = get(_lowerQualityIsometry, 'status')
  const lowQualityFramePercent = get(_lowerQualityIsometry, 'percent')

  const setFrames  = useFocusSet(_isometry, 'frames')
  const setPercent = useFocusSet(_isometry, 'percent')
  const setStatus  = useFocusSet(_isometry, 'status')
  const setConfig  = useFocusSet(_isometry, 'config')

  useEffect(() => {
    const lowQualityDone = lowQualityFramePercent === '100' && lowQualityFrameStatus === 'DONE'
    const shouldWait     = config?.[0]?.SHOULD_LOOK_FOR_LOWER_QUALITY

    if (config && mono && (!shouldWait || lowQualityDone)) {
      const i   = config[0]
      const PID = i.PROJECT_ID
      const NUM = i.IMAGE_NUM
      const INI = i.FIRST_IMAGE
      const EXT = i.FILE_EXT
      const SUB = i.PNG_PATH

      const FNC = x => `${ISO_FRAMES}${SUB}/${x + INI}.${EXT}`
      const COL = array(NUM, FNC)

      setConfig([{ [PID]: i }])
      setPercent([{ [PID]: '0' }])
      setStatus ([{ [PID]: 'FETCHING' }])

      const loadAll = async () => {
        const ARR       = new Array(NUM)
        let loadedCount = 0
        const BATCH     = 10

        for (let start = 0; start < COL.length; start += BATCH) {
          const chunk = COL.slice(start, start + BATCH)

          await Promise.all(
            chunk.map(async (val, chunkIdx) => {
              const idx = start + chunkIdx
              try {
                const bitmap = await preloadImage(val)
                ARR[idx]     = { [INI + idx]: bitmap }
              } catch {
                ARR[idx]     = { [INI + idx]: null }
              }

              loadedCount += 1
              const percent = Math.min(100, Math.floor((loadedCount / NUM) * 100)).toFixed()
              setPercent([{ [PID]: percent }])
            })
          )

          // yield to browser between batches — keeps UI responsive
          await new Promise(resolve => setTimeout(resolve, 0))
        }

        // ✅ set once after ALL frames loaded
        setFrames([{ [PID]: ARR }])
        setStatus([{ [PID]: 'DONE' }])
      }

      loadAll()
    }
  }, [mono, config, lowQualityFramePercent, lowQualityFrameStatus])

  return null
}